import React,  { useState, useEffect } from 'react';
import {FormControl , TextField, Grid , Box,  MenuItem ,LinearProgress, Typography,InputLabel,Button } from '@mui/material/';

import axios from 'axios';

import { DataGrid, GridToolbar,frFR } from '@mui/x-data-grid';

import Autorize from '../../components/ui/autorize';
import Cookies from 'js-cookie'
import DialogYesNo from '../../components/lib/dialog_yes_no';


//https://react-data-table-component.netlify.app/?path=/docs/examples-filtering--filtering
function GenererFactureTrimestre() {

    const [openQuestion, setOpenQuestion] = React.useState(false);
    const [clublist, setList] = useState("");

    const [clubid, setclubid] = useState(""); 
    const [secteur, setSecteur] = useState(""); 
    const [autorize, setAutorize] = useState("false");
    const [errorAxios, setErrorAxios] = useState("false");
    const [OptionStatusClub, setOptionStatusClub] = useState([]);
    const [displayProgress, setDisplayProgress] = useState(false); 


 /*
    const MyAxios = axios.create({
        headers: { 'Access-Control-Allow-Origin':  process.env.REACT_APP_API},       
        withCredentials: true,
        xsrfCookieName: 'token',
        xsrfHeaderName: 'X-XSRF-TOKEN',
    })*/
    const MyAxios = axios.create({    
        headers: { Authorization: "Bearer "+ Cookies.get('token'),
                }      
  })

   
    
  useEffect(() => {
        
            if(autorize)
            if(clublist === "" )
            {          
                //, { headers: { Authorization: "Bearer "+ cookies }}
                MyAxios.get(process.env.REACT_APP_API + '/clubs/getallFactureTrimestre') //axios.defaults.withCredentials = true
                .then((res) => {      
                    setErrorAxios(false);
                    console.log(res);
                    setList(res.data);
                
                })
                .catch((error) => {
                    console.log(error)  
                    setErrorAxios(true);                 

                });
            }
            

    }, []);


    function RefreshRepport()
    {                      
            //, { headers: { Authorization: "Bearer "+ cookies }}
            MyAxios.get(process.env.REACT_APP_API + '/clubs/getallFactureTrimestre') //axios.defaults.withCredentials = true
            .then((res) => {      
                setErrorAxios(false);
                console.log(res);
                setList(res.data);
            
            })
            .catch((error) => {
                console.log(error)  
                setErrorAxios(true);                 

            });     
        
    }

  
    function onCloseDialog() {
        setOpenQuestion(false);
    }
    
    function onOpenDialog() {
        setOpenQuestion(true);
    }

    function GenererFatureTrimestreALL(response)
    { 
        if(response === true)
        {   
             alert("Ce processus est maintenant fait d'une autre méthode ");//par gcp cron de nuit
             //GenererFatureTrimestre("all");
        }
        else
            alert("La prochaine fois .... Merci");
        
         
        
    }

    function SendFactureTrimestre(row)
    {    
       // alert(row.id);
        //alert("Par souci de sécurité, le processus arrête ici, il sera réactivé en périote de facturation... Aucune facture créer ");
         GenererFatureTrimestre(row.id);
    }
         
    function GenererFatureTrimestre(ClubId) { 
           // alert(process.env.REACT_APP_API + "/clubs/nouveauclub/");  

           setDisplayProgress(true);
          // console.log(Number(ClubId) > 0 );
           if(!(Number(ClubId) > 0 ))
                 ClubId = "all"; // replace by all all 

     
        
            MyAxios.get(process.env.REACT_APP_API + "/woo/placeTrimestreOrder/"+ ClubId)    
            .then((res) => {       
                  console.log("resp  -->" , res);
                if(res.status === 200)    
                {  
                    
                    if(res.data.custom == "error")
                    {
                        alert("Erreur de facture:" + JSON.stringify(res.data.err));
                        setDisplayProgress(false);
                    }
                    else
                    {                        
                                MyAxios.get(process.env.REACT_APP_API + "/woo/syncOrder/")    
                                .then((res) => {       
                                   
                                    console.log(res)
                                    if(res.status === 200)    
                                    {  
                                        RefreshRepport();
                                        setDisplayProgress(false);
                                        alert("Facture synchroniser aves la BD, si rien ne s'affiche, rafraîchir la page...");   
                                    }
                                    
                                    else    
                                    {
                                        setDisplayProgress(false); 
                                        alert("Erreur de synchronisation avec la BD")
                                                                            }
                                        
                                    
                                })
                                .catch((error) => {
                                    setDisplayProgress(false);
                                    console.log(error)               
                                    alert("Erreur sauvegarde")
                                });                               
                     }                 
                       
                }
            })
            .catch((error) => {
                console.log(error)               
                alert("Erreur sauvegarde")
            });
        
    }


/*
    handleChange(event) {  
        console.log(event.target);
        this.setState({[event.target.id]: event.target.value});  
      }
*/
    
    const callbackAutoriser = (index) => { // the callback. Use a better name      
        setAutorize(index);     
    };

    

    const columns = [           
        {      field: 'id',            headerName: 'Numéro de club' ,           width:100},           
        {      field: 'Club_Type',     headerName: 'Type de club',     width:150},  
        {      field: 'ClubLegalName', headerName: 'Nom légal', width:400},
        {      field: 'Status',        headerName: 'Statut',        width:100},       
        {      field: 'Status_Reason', headerName: 'Raison du statut', width:125},             
        {      field: 'Incorporated',  headerName: 'Incorporé',  width:100}, 
        {      field: 'SportsClub',    headerName: 'Club à vocation unique',    width:170},   
        {      field: 'CollegeClub',   headerName: 'Club universitaire',   width:130},       
       /* {
            field: "action",
            headerName: "Facturation",
            sortable: false,
            width:300,
            renderCell: ({ row }) =>
              <Button onClick={() => SendFactureTrimestre(row)}>
                Envoyer la facture trimestriel
              </Button>,
          }, */    
        {      field: 'dateFacture',   headerName: 'Dernière Facture',   width:190}, 
        {      field: 'total',   headerName: 'Solde',   width:100},   
        {      field: 'items',   headerName: 'Items non payé',   width:400},
    ];


    function displayProgressBar()
    {

        if(displayProgress === true)
            return ( <Box sx={{  borderRadius: 3,padding:3,margin:1 , width: '80%',  }}  style={{ border: "1px solid grey" }}>
                            <Typography variant="h7" gutterBottom>Le processus peut prendre 10 et 15 minutes... Attendez. Merci </Typography>
                            <LinearProgress />
                    </Box>);
        
        return ;

    }




    /*********************** button pour réer la facturation trimestriel manuellement, maintenant automatique *************************
    <Grid item container direction="row" > 
                            <Box sx={{ borderRadius: 3,padding:1,margin:1}}  style={{ border: "1px solid grey" }}>
                                <Button onClick={onOpenDialog} variant="containedFifth">CLIQUEZ ICI POUR GÉNÉRER TOUTES LES FACTURES DE RENOUVELLEMENT DE MEMRES RÉGULIERS, MEMBRE COLLÉGIAL ET MEMBRE À VIE DE TOUS LES CLUB</Button>                             
                            </Box>
                        
                           
                            {displayProgressBar()}    
                        
                        </Grid>

    *********************************************************************************************************************************************/

    return (
            <div>
                <Autorize axiosError={errorAxios} callBackAutoriser={callbackAutoriser}/>
            <form>
                  <Typography  variant='h6' ml={4} sx={{ fontSize: 17 }}> Facture en attente de paiement</Typography>
                   <Grid container direction="row" spacing={2}  m={2}>
                                                                  
                        
                        <Grid item container direction="row" > 
                                <div style={{ height: '1000px', width: '90%' }}>
                            
                                    <DataGrid  localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
                                        rows={clublist}
                                        columns={columns}
                                        pageSize={100}
                                        rowsPerPageOptions={[100]}
                                        components={{ Toolbar: GridToolbar }}                                                                
                                    />
                                </div>
                        </Grid>
                        
                </Grid>

       
        </form>

                  
           <DialogYesNo question="Voulez-vous vraiment générer les fature trimestriel de TOUS les clubs ?" onAnswer={GenererFatureTrimestreALL} open={openQuestion} onClose={onCloseDialog}  />


        </div>
    );   

}

export default GenererFactureTrimestre;

/*
 old facturation box.
  <Box sx={{ borderRadius: 3,padding:1,margin:1}}  style={{ border: "1px solid grey" }}>
                            
                                <Typography variant="h6" gutterBottom>Facturation</Typography>                                              
                                <InvoiceBilling key="invoicebill"  clubid={clubid} secteur={secteur}  />
                                
   </Box>

*/